export function computeHotelDiscountPrice(data, savingsPercent, nightsCount, roomCount) {
    return (data.display_total / (1 - (savingsPercent || 0) / 100) - data.display_total);
}
export function computeHotelDiscountTotalPrice(total, savingsPercent) {
    return total / (1 - (savingsPercent || 0) / 100) - total;
}
export function computeHotelDiscountTotalPriceV2(display, original, nightCount, roomCount) {
    if (original === void 0) { original = 0; }
    if (original < display)
        return 0;
    var displayTotal = display * nightCount * roomCount;
    var originalTotal = original * nightCount * roomCount;
    return Math.ceil(originalTotal) - Math.ceil(displayTotal);
}
